(function () {
  var hasManualFilterOrSort = false;

  function toLower(value) {
    return String(value || '').toLowerCase().trim();
  }

  function isRecentValue(value) {
    var v = toLower(value);
    return (
      v.indexOf('most_recent') !== -1 ||
      v.indexOf('most-recent') !== -1 ||
      v.indexOf('most recent') !== -1 ||
      v === 'recent' ||
      v === 'newest'
    );
  }

  function isRecentText(value) {
    var v = toLower(value);
    return v.indexOf('most recent') !== -1 || v.indexOf('newest') !== -1 || v.indexOf('latest') !== -1;
  }

  function isPicturesFirstValue(value) {
    var v = toLower(value);
    return (
      v.indexOf('pictures_first') !== -1 ||
      v.indexOf('pictures-first') !== -1 ||
      v.indexOf('pictures first') !== -1 ||
      v.indexOf('photos_first') !== -1 ||
      v.indexOf('photos-first') !== -1 ||
      v.indexOf('photos first') !== -1
    );
  }

  function isPicturesFirstText(value) {
    var v = toLower(value);
    return (
      v.indexOf('pictures first') !== -1 ||
      v.indexOf('photos first') !== -1 ||
      v.indexOf('picture first') !== -1 ||
      v.indexOf('photo first') !== -1
    );
  }

  function getPictureFirstOption(select) {
    if (!select || !select.options || !select.options.length) {
      return null;
    }

    var i;
    var option;

    for (i = 0; i < select.options.length; i += 1) {
      option = select.options[i];
      if (isPicturesFirstValue(option.value)) {
        return option;
      }
    }

    for (i = 0; i < select.options.length; i += 1) {
      option = select.options[i];
      if (isPicturesFirstText(option.text)) {
        return option;
      }
    }

    return null;
  }

  function getMostRecentOption(select) {
    if (!select || !select.options || !select.options.length) {
      return null;
    }

    var i;
    var option;

    for (i = 0; i < select.options.length; i += 1) {
      option = select.options[i];
      if (isRecentValue(option.value)) {
        return option;
      }
    }

    for (i = 0; i < select.options.length; i += 1) {
      option = select.options[i];
      if (isRecentText(option.text)) {
        return option;
      }
    }

    return null;
  }

  function getSortSelects(root) {
    var context = root || document;
    var selectors = [
      'select.jdgm-sort-dropdown',
      '.jdgm-sort-dropdown select',
      '.jdgm-rev-widg select',
      '#judgeme_all_reviews_page select',
      '.jdgm-all-reviews-page select',
    ];
    var list = [];
    var seen = new Set();
    var i;
    var j;
    var found;
    var el;

    for (i = 0; i < selectors.length; i += 1) {
      found = context.querySelectorAll(selectors[i]);
      for (j = 0; j < found.length; j += 1) {
        el = found[j];
        if (!el || el.tagName !== 'SELECT') {
          continue;
        }
        if (seen.has(el)) {
          continue;
        }
        seen.add(el);
        list.push(el);
      }
    }

    return list;
  }

  function isSortControl(element) {
    if (!element || element.tagName !== 'SELECT') {
      return false;
    }

    return element.matches(
      'select.jdgm-sort-dropdown, .jdgm-sort-dropdown select, .jdgm-rev-widg select, #judgeme_all_reviews_page select, .jdgm-all-reviews-page select'
    );
  }

  function applyDefaultSort(root) {
    if (hasManualFilterOrSort) {
      return;
    }

    var selects = getSortSelects(root);
    var i;
    var select;
    var option;

    for (i = 0; i < selects.length; i += 1) {
      select = selects[i];
      option = getPictureFirstOption(select) || getMostRecentOption(select);

      if (!option) {
        continue;
      }

      if (toLower(select.value) === toLower(option.value)) {
        continue;
      }

      select.value = option.value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function hasJudgeMeWidget() {
    return Boolean(
      document.querySelector(
        '.jdgm-rev-widg, #judgeme_all_reviews_page, .jdgm-all-reviews-page, .jdgm-widget:not(.jdgm-preview-badge)'
      )
    );
  }

  function initAutoSort() {
    if (!hasJudgeMeWidget()) {
      return;
    }

    var attempts = 0;
    var maxAttempts = 30;

    applyDefaultSort(document);

    var timer = window.setInterval(function () {
      attempts += 1;
      applyDefaultSort(document);

      if (hasManualFilterOrSort || attempts >= maxAttempts) {
        window.clearInterval(timer);
      }
    }, 500);

    var observer = new MutationObserver(function (mutations) {
      if (hasManualFilterOrSort) {
        return;
      }

      var i;
      var j;
      var node;

      for (i = 0; i < mutations.length; i += 1) {
        for (j = 0; j < mutations[i].addedNodes.length; j += 1) {
          node = mutations[i].addedNodes[j];
          if (!node || node.nodeType !== 1) {
            continue;
          }
          if (node.matches && node.matches('.jdgm-widget, .jdgm-rev-widg, .jdgm-sort-dropdown, select')) {
            applyDefaultSort(document);
            return;
          }
          if (
            node.querySelector
            && node.querySelector('.jdgm-widget, .jdgm-rev-widg, .jdgm-sort-dropdown, select')
          ) {
            applyDefaultSort(node);
            return;
          }
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoSort);
  } else {
    initAutoSort();
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!event.isTrusted || !target) {
        return;
      }

      if (
        isSortControl(target) ||
        (target.closest && target.closest('.jdgm-rev-widg__header, #judgeme_all_reviews_page'))
      ) {
        hasManualFilterOrSort = true;
      }
    },
    true
  );

  document.addEventListener('shopify:section:load', function () {
    applyDefaultSort(document);
  });
  document.addEventListener('jdgm:loaded', function () {
    applyDefaultSort(document);
  });
  document.addEventListener('judgeme:loaded', function () {
    applyDefaultSort(document);
  });
})();
